import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Food(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M3.728 2.315a1 1 0 00-1.726.618c-.093 1.409-.03 2.843.13 4.243.13 1.137.36 2.39.77 3.542.405 1.141 1.016 2.265 1.958 3.05a1 1 0 001.335-.05l2.89-2.794 1.25 1.328-7.042 7.04a1 1 0 101.414 1.415l6.999-6.998 6.566 6.976a1 1 0 101.456-1.37l-6.608-7.021.958-.958c1.753 1.109 4.1.9 5.63-.629l2-2a1 1 0 00-1.415-1.414l-2 2a2.536 2.536 0 11-3.586-3.586l2-2a1 1 0 00-1.414-1.414l-2 2a4.537 4.537 0 00-.629 5.629l-.915.915-1.901-2.02-.004-.004-6.116-6.498zm.39 4.634a22.92 22.92 0 01-.116-1.425l3.711 3.943-2.172 2.102c-.292-.415-.544-.927-.755-1.521-.34-.958-.547-2.049-.667-3.1zm15.59-1.242a1 1 0 00-1.415-1.414l-2.5 2.5a1 1 0 001.414 1.414l2.5-2.5z",
    clipRule: "evenodd"
  }));
}

export default Food;